import React, { useMemo } from 'react'
import { Text, useWindowDimensions, View } from 'react-native'
import { useCssStyle } from '../../customHook/getCssStyle'
import CustomPressable from '../customPressable/customPressable';
import RenderHTML from 'react-native-render-html';
import { ImageComp } from '../Image/Image';
import { getCleanUrl } from '../../utils/Helper';

const SmallIconMultipleWidget = (props) => {
    const { listItemData, handleOnWidgetClick, widget } = props || {};

    const { width } = useWindowDimensions()
    const getStyles = useCssStyle();

    const renderItem = (item) => {
        const widgetImg = getCleanUrl(item?.btnImageUrl);
        const widgetMetaHtmlId = item?.widgetMetaHtmlId;

        return (
            <CustomPressable 
                id={`smallIconMultipleWidget_WidgetsContainer smallIconMultipleWidget_WidgetsContainer_${widgetMetaHtmlId} smallIconMultipleWidget_WidgetsContainer_${item.id}`} 
                style={getStyles([
                    'smallIconMultipleWidget_WidgetsContainer',
                    `smallIconMultipleWidget_WidgetsContainer_${widgetMetaHtmlId}`,
                    `smallIconMultipleWidget_WidgetsContainer_${item.id}`,
                ])} 
                onPress={() => handleOnWidgetClick(item)}
            >

                <ImageComp
                    source={widgetImg}
                    style={getStyles([
                        "smallIconMultipleWidget_WidgetsImg",
                        `smallIconMultipleWidget_WidgetsImg_${widgetMetaHtmlId}`,
                        `smallIconMultipleWidget_WidgetsImg_${item.id}`,
                    ])}
                    id={`smallIconMultipleWidget_WidgetsImg smallIconMultipleWidget_WidgetsImg_${widgetMetaHtmlId} smallIconMultipleWidget_WidgetsImg_${item.id}`}
                />

                <View 
                    style={getStyles([
                        'smallIconMultipleWidget_WidgetsTitleContainer',
                        `smallIconMultipleWidget_WidgetsTitleContainer_${widgetMetaHtmlId}`,
                        `smallIconMultipleWidget_WidgetsTitleContainer_${item.id}`,
                    ])} 
                    id={`smallIconMultipleWidget_WidgetsTitleContainer smallIconMultipleWidget_WidgetsTitleContainer_${widgetMetaHtmlId} smallIconMultipleWidget_WidgetsTitleContainer_${item.id}`} 
                >
                    {item?.widgetTitle && 
                        <Text 
                            style={getStyles([
                                'smallIconMultipleWidget_WidgetsTitleText',
                                `smallIconMultipleWidget_WidgetsTitleText_${widgetMetaHtmlId}`,
                                `smallIconMultipleWidget_WidgetsTitleText_${item.id}`,
                            ])} 
                            id={`smallIconMultipleWidget_WidgetsTitleText smallIconMultipleWidget_WidgetsTitleText_${widgetMetaHtmlId} smallIconMultipleWidget_WidgetsTitleText_${item.id}`}
                        >
                            {item?.widgetTitle}
                        </Text>
                    }

                    {item.buttonTitle &&
                        <View
                            style={getStyles([
                                'smallIconMultipleWidget_WidgetsButtonContainer',
                                `smallIconMultipleWidget_WidgetsButtonContainer_${widgetMetaHtmlId}`,
                                `smallIconMultipleWidget_WidgetsButtonContainer_${item.id}`,
                            ])} 
                            id={`smallIconMultipleWidget_WidgetsButtonContainer smallIconMultipleWidget_WidgetsButtonContainer_${widgetMetaHtmlId} smallIconMultipleWidget_WidgetsButtonContainer_${item.id}`}
                        >
                            <Text 
                                style={getStyles([
                                    'smallIconMultipleWidget_WidgetsButtonContainerText',
                                    `smallIconMultipleWidget_WidgetsButtonContainerText_${widgetMetaHtmlId}`,
                                    `smallIconMultipleWidget_WidgetsButtonContainerText_${item.id}`,
                                ])} 
                                id={`smallIconMultipleWidget_WidgetsButtonContainerText smallIconMultipleWidget_WidgetsButtonContainerText_${widgetMetaHtmlId} smallIconMultipleWidget_WidgetsButtonContainerText_${item.id}`}
                            >
                                {item.buttonTitle}
                            </Text>
                        </View>
                    }
                </View>
            </CustomPressable>
        );
    };



    const customWidgetTitleStyle = useMemo(() => {
        const style = getStyles(["smallIconMultipleWidgetTitleText", `smallIconMultipleWidgetTitleText_${listItemData[0].widgetMetaHtmlId}`])
        return Array.isArray(style) ? Object.assign({}, ...style) : style || {};
    
        // eslint-disable-next-line react-hooks/exhaustive-deps 
    }, []);
    
    const customWidgetDescriptioneStyle = useMemo(() => {
        const style = getStyles(["smallIconMultipleWidgetDescriptionText", `smallIconMultipleWidgetDescriptionText_${listItemData[0].widgetMetaHtmlId}`])
        return Array.isArray(style) ? Object.assign({}, ...style) : style || {};
    
        // eslint-disable-next-line react-hooks/exhaustive-deps 
    }, []);

    return (
        <View style={getStyles(["smallIconMultipleWidgetContainer", `smallIconMultipleWidgetContainer_${listItemData[0].widgetMetaHtmlId}`])} id={`smallIconMultipleWidgetContainer smallIconMultipleWidgetContainer_${listItemData[0].widgetMetaHtmlId}`} >
            <View style={getStyles(["smallIconMultipleWidgetTitleContainer", `smallIconMultipleWidgetTitleContainer_${listItemData[0].widgetMetaHtmlId}`])} id={`smallIconMultipleWidgetTitleContainer smallIconMultipleWidgetTitleContainer_${listItemData[0].widgetMetaHtmlId}`} >
                <View style={getStyles(["smallIconMultipleWidgetTitleTextContainer", `smallIconMultipleWidgetTitleTextContainer_${listItemData[0].widgetMetaHtmlId}`])} id={`smallIconMultipleWidgetTitleTextContainer smallIconMultipleWidgetTitleTextContainer_${listItemData[0].widgetMetaHtmlId}`}>
                    {widget?.displayName && <RenderHTML
                        contentWidth={width}
                        baseStyle={customWidgetTitleStyle}
                        source={{ html: widget?.displayName}}
                        systemFonts={[customWidgetTitleStyle.fontFamily]}
                        id={`smallIconMultipleWidgetTitleText`}
                    />}
                    {widget?.widgetDesc && <RenderHTML
                        contentWidth={width}
                        baseStyle={customWidgetDescriptioneStyle}
                        source={{ html: widget?.widgetDesc}}
                        systemFonts={[customWidgetDescriptioneStyle.fontFamily]}
                        id={`smallIconMultipleWidgetDescriptionText`}
                    />}
                </View>
            </View>

            <View style={getStyles(["smallIconMultipleWidgetItemsMainContainer", `smallIconMultipleWidgetItemsMainContainer_${listItemData[0].widgetMetaHtmlId}`])} id={`smallIconMultipleWidgetItemsMainContainer smallIconMultipleWidgetItemsMainContainer_${listItemData[0].widgetMetaHtmlId}`}>
                {listItemData?.map(renderItem)}
            </View>
        </View>
    )
}

export default SmallIconMultipleWidget
